// HueBar.tsx
import { useRef, useEffect } from 'react';

interface HueBarProps {
  hue: number;
  onChange: (hue: number) => void;
  className?: string;
}

export const HueBar = ({ hue, onChange, className = '' }: HueBarProps) => {
  const hueBarRef = useRef<HTMLDivElement>(null);
  const isDragging = useRef(false);

  const handleHueSelect = (clientX: number) => {
    if (!hueBarRef.current) return;

    const rect = hueBarRef.current.getBoundingClientRect();
    const x = Math.max(0, Math.min(clientX - rect.left, rect.width));
    const newHue = Math.round((x / rect.width) * 360);

    onChange(newHue);
  };

  const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
    isDragging.current = true;
    handleHueSelect(e.clientX);
  };

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    handleHueSelect(e.clientX);
  };

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (isDragging.current) {
        handleHueSelect(e.clientX);
      }
    };

    const handleMouseUp = () => {
      isDragging.current = false;
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, []);

  return (
    <div
      ref={hueBarRef}
      className={`relative w-full h-6 rounded-lg cursor-pointer shadow-inner ${className}`}
      style={{
        background:
          'linear-gradient(to right, #ff0000 0%, #ffff00 17%, #00ff00 33%, #00ffff 50%, #0000ff 67%, #ff00ff 83%, #ff0000 100%)'
      }}
      onMouseDown={handleMouseDown}
      onClick={handleClick}
    >
      {/* Curseur de teinte */}
      <div
        className="absolute w-3 h-8 border-2 border-white rounded pointer-events-none"
        style={{
          left: `${(hue / 360) * 100}%`,
          top: '50%',
          transform: 'translate(-50%, -50%)',
          boxShadow: '0 0 0 1px rgba(0,0,0,0.3), 0 2px 4px rgba(0,0,0,0.2)'
        }}
      />
    </div>
  );
};
